/**
 * Expands a `front.displayField` template — a bare field identifier
 * (`'name'`) or a `'{code} - {name}'` interpolation pattern — against a
 * record, substituting each `{<field>}` placeholder with the record's value
 * at that key. A bare identifier is treated equivalently to its
 * curly-wrapped form. A `null`/`undefined` field value expands to an empty
 * string; anything outside a placeholder (including a separator like `' - '`)
 * is emitted verbatim.
 *
 * Single source of truth for the `{field}` interpolation shared by
 * `ToOptionsPipe` (search-select family) and `itemLabelOf` (select /
 * multiple-select family) — both widget families render the identical label
 * for the identical `displayField`.
 *
 * @example
 * ```ts
 * expandDisplayFieldTemplate('name', { name: 'Foo' }); // 'Foo'
 * expandDisplayFieldTemplate('{code} - {name}', { code: 'AB', name: 'Foo' }); // 'AB - Foo'
 * ```
 */
export function expandDisplayFieldTemplate(
  template: string,
  item: Record<string, unknown>,
): string {
  const expr = /\{/.test(template) ? template : `{${template}}`;
  return expr.replace(/\{(\w+)\}/g, (_, key: string) => {
    const value = item[key];
    return value == null ? '' : String(value);
  });
}
